import VisitReviews from '../../views/visitReviews/VisitReviews';

export default [{ path: '/visit-reviews', breadcrumb: 'Ocena zdjęć', Component: VisitReviews }];
